// extracted by mini-css-extract-plugin
export default {"input":"FormulaireYScale_input__NhsVt","btnn":"FormulaireYScale_btnn__VVt1Z"};